import React from "react";
import { registerUIComponent } from "../engine";
import { getAddressColor } from "@latticexyz/std-client";
import { EntityID, getComponentValue, Has, Not, runQuery } from "@latticexyz/recs";
import { map, merge } from "rxjs";
import { computedToStream } from "@latticexyz/utils";

export function registerJoinGame() {
  registerUIComponent(
    "JoinGameWindow",
    {
      colStart: 6,
      colEnd: 7,
      rowStart: 1,
      rowEnd: 3,
    },
    (layers) => {
      const {
        headless: {
          api: { joinGame },
        },
        network: {
          network: { connectedAddress },
          components: { Player, SpawnPoint, OwnedBy },
          world,
        },
        local: {
          components: { Selected, LocalPosition },
        },
      } = layers;

      return merge(computedToStream(connectedAddress), Selected.update$, Player.update$).pipe(
        map(() => connectedAddress.get()),
        map((address) => {
          const playerEntity = world.entityToIndex.get(address as EntityID);
          
          const selectedSpawnPoint = [...runQuery([Has(Selected), Has(SpawnPoint), Not(OwnedBy)])][0];
          const position = getComponentValue(LocalPosition, selectedSpawnPoint);

          return {
            joinGame,
            selectedSpawnPoint,
            position,
            playerEntity,
            address,
          };
        })
      );
    },
    ({ joinGame, playerEntity, selectedSpawnPoint, position, address }) => {
      const joined = playerEntity != undefined;
      const playerColor = getAddressColor(address || "");

      return (
        <div>
          {!joined && <h1>Join Game</h1>}
          <p style={{ color: playerColor.toString(16) }}>Address: {address}</p>
          <p>Joined? {joined ? "yes" : "no"}</p>
          {!joined && selectedSpawnPoint != null && (
            <button
              onClick={() => {
                joinGame(selectedSpawnPoint);
              }}
            >
              Join at Position ({position?.x},{position?.y})
            </button>
          )}
        </div>
      );
    }
  );
}
